import { render } from "./Single_blog.vue?vue&type=template&id=7fa1e126&scoped=true"
import script from "./Single_blog.vue?vue&type=script&lang=js"
export * from "./Single_blog.vue?vue&type=script&lang=js"

import "./Single_blog.vue?vue&type=style&index=0&id=7fa1e126&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa1e126"]])

export default __exports__